import type { UsFill } from '@/lib/polymarketUs/fillsClient';
import { usUsdToCentsText } from '@/lib/polymarketUs/format';

/** #1007: exact US price display. Shifts the decimal point two places in the
 *  string ('0.4567' -> '45.67'); never converts to a number, so sub-cent
 *  prices survive exactly. The shared US format rule; throws on text that is
 *  not a plain non-negative decimal. */
export function usDollarsToCents(price: string): string {
  const cents = usUsdToCentsText(price);
  if (cents === null) throw new Error('US_PRICE_INVALID');
  return cents;
}

/** #1015: shared wording for the rail and Trader Detail, so both explain a US value the same way. */
export const US_PROVISIONAL_TITLE = 'provisional: derived from the venue YES price';
export const US_CONFLICT_TITLE = 'conflicting venue evidence';
export const usPriceDashTitle = (basis: UsFill['priceBasis']) =>
  basis === 'missing' ? 'price missing' : basis === 'disputed' ? 'price disputed' : 'price unverified';
